import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavLink } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import logo from './../shortscreatorlogo.png';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

function Header() {
    return (
        <Navbar className="bg-body-tertiary">
            <Container className="d-flex align-items-center">
                <Navbar.Brand href="/"><img width="70" height="70" src={logo} alt='Shorts Creator' /></Navbar.Brand>
                {/* Only three short links — keep them inline on every screen size (no hamburger),
                    so Home, Privacy Policy and Terms are always visible without opening a menu.
                    flex-wrap lets them drop to a second line on very small phones while staying visible. */}
                <Nav className="ms-auto flex-row flex-wrap gap-2">
                    <NavLink to="/" className="nav-link" >Home</NavLink>
                    <NavLink to="/privacy" className="nav-link" >Privacy Policy</NavLink>
                    <NavLink to="/terms" className="nav-link" >Term Of Use</NavLink>
                </Nav>
            </Container>
        </Navbar>
    );
}

export default Header;
